"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateSettingsService = void 0;
var settings_1 = require("@wix/wix-vod-api-site-based/dist/src/private/services/settings/settings");
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var success_response_1 = require("./parsers/success-response");
var to_error_1 = require("../../parsers/to-error");
var PrivateSettingsService = /** @class */ (function () {
    function PrivateSettingsService(httpClient) {
        var _this = this;
        this.httpClient = httpClient;
        this.get = function () {
            return _this.privateSettingsService
                .getSettings()
                .then(success_response_1.parseSuccessResponse)
                .catch(to_error_1.toError);
        };
        this.update = function (settings) {
            return _this.privateSettingsService
                .update((0, object_1.keysToSnakeCase)(settings))
                .then(success_response_1.parseSuccessResponse)
                .catch(to_error_1.toError);
        };
        this.reset = function () {
            return _this.privateSettingsService
                .reset()
                .then(function (response) { return response.data; })
                .catch(to_error_1.toError);
        };
        this.privateSettingsService = new settings_1.PrivateSettings(httpClient);
    }
    return PrivateSettingsService;
}());
exports.PrivateSettingsService = PrivateSettingsService;
//# sourceMappingURL=settings.js.map